import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import PropTypes from 'prop-types';
// import FancyCutProRegular from '../../assets/fonts/FancyCutPro-Regular.woff';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 60,
    fontStyle: 'italic',
    padding: theme.spacing(1.5, 0),
    marginBottom: theme.spacing(2),
  },
  mobileRoot: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

const SubpageTitle = ({
  text,
  className,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Typography
      className={clsx(classes.root, mobile && classes.mobileRoot, className)}
      variant="subtitle1"
    >
      {text}
    </Typography>
  );
};

SubpageTitle.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SubpageTitle.defaultProps = {
  className: undefined,
};

export default SubpageTitle;
